export default __webpack_public_path__ + "static/media/menu-want-to-watch.8e30e84e.svg";